var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4785 8.16745L9.59006 4.28003V6.2235H5.70215V10.1114H9.59006V12.0554L13.4785 8.16745Z",
    fill: "#ED8A00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.40525 14.6493H7.64619C8.00399 14.6493 8.29438 14.3589 8.29438 14.0011C8.29438 13.6427 8.00399 13.3529 7.64619 13.3529H4.40525C3.6903 13.3529 3.10888 12.7715 3.10888 12.0566V4.2783C3.10888 3.56335 3.6903 2.98192 4.40525 2.98192H7.64619C8.00399 2.98192 8.29438 2.69218 8.29438 2.33374C8.29438 1.97529 8.00399 1.68555 7.64619 1.68555H4.40525C2.97924 1.68555 1.8125 2.85229 1.8125 4.2783V12.0566C1.8125 13.4826 2.97924 14.6493 4.40525 14.6493Z",
    fill: "#ED8A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnd);
export default __webpack_public_path__ + "static/media/end.cf614d2a735d25fdcf37040b19fe3cc3.svg";
export { ForwardRef as ReactComponent };